import { Typography } from "antd";
import { observer } from "mobx-react-lite";
import React from "react";

interface Data {
  name: string;
}

interface Props {
  data: Data;
}
const TableUser = (props: Props) => {
  return <Typography.Text>{props.data?.name}</Typography.Text>;
};

export default observer(TableUser);
